//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: [],
	data: function data() {
		return {
			roles: [],
			updateCategory: {}
		};
	},

	methods: {
		getRolesAndPermissions: function getRolesAndPermissions() {

			var self = this;

			window.axios.get('/prototype/settings/roles-and-permissions').then(function (response) {

				self.roles = response.data.roles;

				// updateCategory
				self.roles.forEach(function (element, index) {

					self.updateCategory[element.id] = false;
				});
			});
		}
	},
	mounted: function mounted() {

		this.getRolesAndPermissions();
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/settings/users/RolesWithPermissionsContainer.vue
// module id = fmjj
// module chunks = 0 1